<div class="background">
<div class="activation-wrapper">
  <mat-card appearance="outlined">
    <div class="header-wrapper">
        <div class="header-content">
            <img src="../assets/images/logos/btrust.svg" alt="B-trust Borica logo">
        </div>
        <div class="header-content">
            <span>{{'activation.header' | translate}}</span>
        </div>
    </div>

    <div *ngIf="isBissStep()">
      <cloud-biss-check (stepCompleteEvent)="openNextStep($event)"></cloud-biss-check>
    </div>

    <div *ngIf="isOTPStep()">
      <cloud-otp-validation [activationData]="activationData" (stepCompleteEvent)="openNextStep($event)"></cloud-otp-validation>
    </div>    
    <div *ngIf="isPINStep()">
      <cloud-pin-puk [activationData]="activationData" (stepCompleteEvent)="openNextStep($event)"></cloud-pin-puk>
    </div>
    <div *ngIf="isDocumentStep()">
      <cloud-documents [activationData]="fullActivationData"></cloud-documents>
    </div>
    
  </mat-card>
</div>

</div>